import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical, BadgeDollarSign } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const AdminModeSwitch = () => {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/mode").then(({ data }) => setM(data)); }, []);
  if (!m) return null;
  const prod = m.mode === "prod";
  const flip = async () => {
    const next = prod ? "test" : "prod";
    const msg = next === "prod"
      ? "Switch to LIVE? Customers pay real money through your live Stripe account, and paid orders are sent to Printify to print and ship."
      : "Switch to TEST? Customers pay with Stripe's test card (4242 4242 4242 4242), no real money moves, and Printify orders are only drafts.";
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { const { data } = await api.put("/admin/mode", { mode: next }); setM(data); toast.success(`Now in ${next.toUpperCase()} mode`); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className={`mt-6 flex flex-col gap-5 rounded-2xl border-4 p-6 sm:flex-row sm:items-center sm:justify-between ${prod ? "border-[#2E6930] bg-[#EEF6EE]" : "border-[#D97706] bg-[#FFF7E6]"}`} data-testid="app-mode-panel">
      <div className="flex items-center gap-4">
        {prod ? <BadgeDollarSign size={44} className="text-[#2E6930]" /> : <FlaskConical size={44} className="text-[#D97706]" />}
        <div>
          <p className="font-serif text-3xl font-bold" data-testid="app-mode-label">{prod ? "PROD mode" : "TEST mode"}</p>
          <p className="text-lg text-[#4A3B32]">{prod ? "Real payments through your live Stripe account. Paid orders are printed and shipped by Printify." : "Stripe test card only (4242 4242 4242 4242). No real money moves; Printify orders are drafts."}</p>
        </div>
      </div>
      <button
        type="button" role="switch" aria-checked={prod} onClick={flip} disabled={busy}
        className="relative flex h-20 w-64 shrink-0 items-center rounded-full border-4 border-[#2C1E16] bg-white p-1 font-bold transition-colors disabled:opacity-60"
        data-testid="app-mode-switch"
      >
        <span className={`absolute top-1 h-[calc(100%-8px)] w-[calc(50%-4px)] rounded-full transition-transform duration-300 ${prod ? "translate-x-full bg-[#2E6930]" : "translate-x-0 bg-[#D97706]"}`} />
        <span className={`relative z-10 w-1/2 text-center text-2xl ${prod ? "text-[#8C7A6B]" : "text-white"}`}>TEST</span>
        <span className={`relative z-10 w-1/2 text-center text-2xl ${prod ? "text-white" : "text-[#8C7A6B]"}`}>PROD</span>
      </button>
    </div>
  );
};
